import { render, staticRenderFns } from "./list.vue?vue&type=template&id=fcd99fe0&scoped=true"
import script from "./list.vue?vue&type=script&lang=ts"
export * from "./list.vue?vue&type=script&lang=ts"
import style1 from "./list.vue?vue&type=style&index=1&id=fcd99fe0&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fcd99fe0",
  null
  
)

export default component.exports